<template>
  <owal-banner
    class="owal event banner container"
    :class="numberOfAlertsSources === 1 ? 'full-size' : 'split'"
  >
    <owal-event-banner-timeline
      :unix-epoch-milliseconds="unixEpochMilliseconds"
      :dot-color="dotColor"
    />
    <owal-event-banner-poster-frame
      style="margin: 0 0 0 0.5rem;"
      :poster-frame-small="posterFrame"
      :poster-frame-large="fullFrame"
      :title="posterFrameTitle"
      :subtitle="posterFrameSubtitle"
      :face-confidence="faceConfidence"
      :match-confidence-level="matchConfidenceLevel"
      :shapes="shapes"
      :clahe="clahe"
      :detection-id="detectionId"
      :buttons="posterButtons"
    />
    <slot
      name="content"
      class="owal event banner content"
    >
      <!-- The content of the banner goes here. -->
    </slot>
  </owal-banner>
</template>

<script>
import OwalBanner from './OwalBanner'
import OwalEventBannerTimeline from './OwalEventBannerTimeline'
import OwalEventBannerPosterFrame from './OwalEventBannerPosterFrame'
import { mapGetters } from 'vuex'
import { DomainPreferences } from '@/libraries/permissions/domainPreferences'

export default {
  name: 'OwalEventBanner',
  components: {
    OwalBanner,
    OwalEventBannerTimeline,
    OwalEventBannerPosterFrame,
  },
  props: {
    /**
     * A URL pointing to the full frame of the event.
     */
    fullFrame: {
      type: String,
    },
    /**
     * A URL pointing to the poster frame of the event.
     */
    posterFrame: {
      type: String,
    },
    shapes: {
      type: Boolean,
      default: false,
    },
    clahe: {
      type: Boolean,
      default: false,
    },
    /**
     * The title of the poster frame. (Often blank, or the camera that the frame is from.)
     */
    posterFrameTitle: {
      type: String,
    },
    /**
     * The subtitle of the poster frame.
     */
    posterFrameSubtitle: {
      type: String,
    },
    /**
     * The dot color.
     */
    dotColor: {
      type: String,
    },
    /**
     * The confidence that this is a face.
     */
    faceConfidence: {
      type: Number,
      default: undefined,
    },
    matchConfidenceLevel: {
      type: Number,
      required: false,
      default: undefined,
    },
    /**
     * The date of the event, represented as a number of seconds since the Unix epoch date.
     * You can obtain this from any date object by calling `valueOf()` on it.
     *
     * @default unixEpochMilliseconds The offset of the current date.
     */
    unixEpochMilliseconds: {
      type: Number,
      default: function () {
        return new Date().valueOf()
      },
    },
    /**
     * The detection ID.
     */
    detectionId: {
      type: String,
    },
    /**
     * An array of buttons for the poster frame.
     */
    posterButtons: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      currentDomain: 'currentDomain',
      preferences: 'preferences',
    }),
    numberOfAlertsSources () {
      let alertSources = this.preferences[DomainPreferences.ALERTS_SOURCE]
      return Array.isArray(alertSources) ? alertSources.length : 1
    },
  },
}
</script>

<style scoped>
.owal.event.banner.container {
  flex-shrink: 0;
  flex-grow: 0;
  padding: 0;
  z-index: 0;
  height: 9rem; /* same as height of  .owal-poster-frame__outer-container */
}

.owal.event.banner.container:hover {
  z-index: 1000;
}

.owal.event.banner.content {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
}

@media screen and (min-width: 68rem) {
  .owal.event.banner.container.split {
    width: 44rem;
  }
  .owal.event.banner.container.full-size {
    width: 68.5714285714rem;
  }

  .owal.event.banner.container >>> .owal-poster-frame__outer-container {
    padding: 0.35rem 0;
  }
}

@media screen and (max-width: 68rem) {
  .owal.event.banner.container.full-size {
    width: 100%;
  }
}
</style>
